import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { withPageTracking } from "../../../services/postHog";
import { Box, Typography } from "@mui/material";
import { FruitifyQuizSearch } from "../components/FruitifyQuizSearch";

const QuizOverviewStudents = () => {
  return (
    <FruitifyContainer>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h3" fontWeight="bold">
          Quizzes
        </Typography>
      </Box>
      <FruitifyQuizSearch excludeTitle studentView />
    </FruitifyContainer>
  );
};

export default withPageTracking(QuizOverviewStudents, {
  feature: "quiz-overview-student",
});
